var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge cursorPoint mt-1",attrs:{"data-ga-element":(_vm.gaData + "tag|" + _vm.badge)},on:{"click":function($event){return _vm.goTagPage(_vm.badge)}}},[_vm._v(" "+_vm._s(_vm.badge)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }